/**
 * The single breakpoint that decides between the file browser's card and
 * table layout (`useViewMode`) — Tailwind's own `lg`, 1024px. Named once so a
 * second raw value can't drift from it, and so the one raw px value the
 * design system has no token for — a viewport width is not a spacing,
 * radius, or colour, and `matchMedia` takes nothing but raw CSS — needs
 * exactly one disable comment.
 */
// eslint-disable-next-line no-restricted-syntax -- see module doc comment above
export const MOBILE_QUERY = '(max-width: 1023px)';

/**
 * Fingers rather than a cursor, for the one thing a viewport width cannot
 * answer: how big a control has to be to be hit.
 *
 * **Not `MOBILE_QUERY`**, and the difference is the point — a 1280px tablet is
 * a wide screen operated by thumbs, and a 900px desktop window is a narrow one
 * operated by a mouse. Asking about width there would grow a control for the
 * second and leave it too small for the first. Carries no px, so unlike the
 * constant above it needs no disable comment.
 *
 * Used by `PdfViewer/Signing/FieldLayer` for the corner controls on a placed
 * signature; nothing else needs it yet.
 */
export const COARSE_POINTER_QUERY = '(pointer: coarse)';
